(function () {
  if (window.TallonFeaturedPedalsSlider) return;

  const instances = new WeakMap();

  function getEmbla() {
    return window.EmblaCarousel;
  }

  function getAdjacentIndex(index, direction, total) {
    return (index + direction + total) % total;
  }

  function getOriginalSlideCount(root) {
    return parseInt(root.dataset.originalSlides || '', 10) || 0;
  }

  function getPhysicalSlideCount(root, embla) {
    return parseInt(root.dataset.physicalSlides || '', 10) || embla.slideNodes().length;
  }

  function getCenteredPhysicalIndex(root, embla, originalIndex) {
    const originalSlideCount = getOriginalSlideCount(root);
    const physicalCount = getPhysicalSlideCount(root, embla);
    if (!originalSlideCount || !physicalCount) return originalIndex;

    const centeredIndex = originalIndex + originalSlideCount;
    return centeredIndex < physicalCount ? centeredIndex : originalIndex;
  }

  function normalizeSelectedPhysicalSlide(root, embla) {
    const originalSlideCount = getOriginalSlideCount(root);
    if (!originalSlideCount) return;

    const selectedIndex = embla.selectedScrollSnap();
    const selectedOriginalIndex = selectedIndex % originalSlideCount;
    const targetIndex = getCenteredPhysicalIndex(root, embla, selectedOriginalIndex);

    if (selectedIndex === targetIndex) return;

    embla.scrollTo(targetIndex, true);
  }

  function updateSlideState(root, embla) {
    const slides = Array.from(root.querySelectorAll('.pedal-card-wrapper'));
    const dots = Array.from(root.querySelectorAll('.featured-pedal-slider__pagination-dot'));
    const selectedIndex = embla.selectedScrollSnap();
    const totalSlides = slides.length;
    const originalSlideCount = getOriginalSlideCount(root);
    const selectedOriginalIndex = originalSlideCount ? selectedIndex % originalSlideCount : selectedIndex;
    const previousIndex = getAdjacentIndex(selectedIndex, -1, totalSlides);
    const nextIndex = getAdjacentIndex(selectedIndex, 1, totalSlides);

    slides.forEach((slide, index) => {
      const isActive = index === selectedIndex;
      const isPrevious = totalSlides > 1 && index === previousIndex && !isActive;
      const isNext = totalSlides > 1 && index === nextIndex && !isActive;

      slide.classList.toggle('is-active', isActive);
      slide.classList.toggle('is-prev', isPrevious);
      slide.classList.toggle('is-next', isNext);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    dots.forEach((dot, index) => {
      dot.classList.toggle('is-active', index === selectedOriginalIndex);
      dot.setAttribute('aria-current', index === selectedOriginalIndex ? 'true' : 'false');
    });
  }

  function buildPagination(root, embla) {
    const pagination = root.querySelector('.featured-pedal-slider__pagination');
    if (!pagination) return;

    pagination.innerHTML = '';
    const originalSlideCount = getOriginalSlideCount(root);
    Array.from({ length: originalSlideCount }).forEach((_, index) => {
      const dot = document.createElement('button');
      dot.className = 'featured-pedal-slider__pagination-dot';
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
      dot.addEventListener('click', () => {
        scrollToOriginalSlide(embla, root, index);
      });
      pagination.appendChild(dot);
    });
  }

  function scrollToOriginalSlide(embla, root, originalIndex) {
    const targetIndex = getCenteredPhysicalIndex(root, embla, originalIndex);
    embla.scrollTo(targetIndex, true);
  }

  function initCarousel(root) {
    if (instances.has(root)) return;

    const EmblaCarousel = getEmbla();
    if (typeof EmblaCarousel !== 'function') return;

    const viewport = root.querySelector('.featured-pedal-slider__viewport');
    const slides = root.querySelectorAll('.pedal-card-wrapper');
    if (!viewport || !slides.length) return;

    const embla = EmblaCarousel(viewport, {
    align: 'center',
    containScroll: false,
    loop: true,
    skipSnaps: false,
    dragFree: false,
    duration: 28,
    startIndex: getOriginalSlideCount(root),
  });

    buildPagination(root, embla);
    updateSlideState(root, embla);
    normalizeSelectedPhysicalSlide(root, embla);

    embla.on('select', () => updateSlideState(root, embla));
    embla.on('settle', () => normalizeSelectedPhysicalSlide(root, embla));
    embla.on('reInit', () => {
      buildPagination(root, embla);
      updateSlideState(root, embla);
      normalizeSelectedPhysicalSlide(root, embla);
    });

    instances.set(root, embla);
    root.classList.add('is-embla-ready');
  }

  function destroyCarousel(root) {
    const embla = instances.get(root);
    if (!embla) return;

    embla.destroy();
    instances.delete(root);
    root.classList.remove('is-embla-ready');
  }

  function initAll(scope) {
    const root = scope instanceof Element ? scope : document;
    root.querySelectorAll('.featured-pedal-slider').forEach(initCarousel);
  }

  function initWhenReady(scope, attempts = 0) {
    if (typeof getEmbla() === 'function') {
      initAll(scope);
      return;
    }

    if (attempts >= 40) return;

    window.setTimeout(() => initWhenReady(scope, attempts + 1), 50);
  }

  window.TallonFeaturedPedalsSlider = {
    init: initWhenReady,
    destroy: destroyCarousel,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWhenReady(document));
  } else {
    initWhenReady(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (section) initWhenReady(section);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = document.getElementById('shopify-section-' + event.detail.sectionId) || event.target;
    if (!section) return;

    section.querySelectorAll('.featured-pedal-slider').forEach(destroyCarousel);
  });
})();
